// setMessageHeightInFeed.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set message height in feed
 * @kind action
 * @param {string} {feedName} - feed name.
 * @param {object} {messageObject} - message object.
 * @return {Promise} Action promise.
 */
const setMessageHeightInFeed =
  ({ feedName, messageObject = {} } = {}) =>
  async dispatch => {
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['feed', feedName, 'message'],
        data: messageObject,
      },
    });
  };

export default setMessageHeightInFeed;
